var render = function render(_c,_vm){return _c('div',{staticClass:"form-row tw-flex tw-flex-col tw-items-start tw-mb-4 md:tw-grid md:tw-gap-x-4 md:tw-mb-7 md:tw-ml-0",class:['tw-grid-cols-' + _vm.props.fields, _vm.data.class, _vm.data.staticClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }